import React, { useState, useEffect, useRef } from 'react';
import { Card, Form, Button, Row, Col, Modal } from 'react-bootstrap';
import { Trash, Plus, ArrowLeftShort, ArrowRightShort, ArrowUpShort, ArrowDownShort } from 'react-bootstrap-icons';
import MenuItem from './MenuItem';
import { Accordion } from 'react-bootstrap';
import '../../src/App.css'

// Update SECTION_TYPES to include an empty default option
const SECTION_TYPES = [
  { id: '', name: 'Scegli categoria' }, // Add empty default option
  { id: 'antipasti', name: 'Antipasti' },
  { id: 'primi', name: 'Primi piatti' },
  { id: 'secondi', name: 'Secondi piatti' },
  { id: 'contorni', name: 'Contorni' },
  { id: 'dolci', name: 'Dolci' },
  { id: 'pizze', name: 'Pizze' },
  { id: 'aperitivo', name: 'Aperitivo' },
  { id: 'piatti unici', name: 'Piatti unici' },
  { id: 'vegetariano', name: 'Vegetariano' },
  { id: 'vegano', name: 'Vegano' },
  { id: 'carne', name: 'Carne' },
  { id: 'pesce', name: 'Pesce' },
  { id: 'piatto del giorno', name: 'Piatto del giorno' },
  { id: 'bevande', name: 'Bevande' },
  { id: 'vini', name: 'Vini' },
  { id: 'birre', name: 'Birre' },
  { id: 'cocktail', name: 'Cocktail' },
  { id: 'servizio', name: 'Servizio' },
];

const MenuSection = ({ 
  section, 
  onUpdateSection, 
  onRemoveSection, 
  onAddItem, 
  onUpdateItem, 
  onRemoveItem, 
  onFileUpload,
  index,
  onMoveSection,
  totalSections
}) => {
  const [showModal, setShowModal] = useState(false);
  const [activeKeys, setActiveKeys] = useState([]);
  const prevItemsLength = useRef(section?.items?.length || 0);

  const handleCloseModal = () => setShowModal(false);
  const handleConfirmDelete = () => {
    if (!section || !section.id) {
      console.error('Sezione non valida o ID mancante');
      return;
    }
    onRemoveSection(section.id);
    handleCloseModal();
  };

  useEffect(() => {
    if (!section?.items) return;

    const currentLength = section.items.length || 0;
    
    if (currentLength > prevItemsLength.current) {
      const lastItem = section.items[currentLength - 1];
      if (lastItem?.id) {
        setActiveKeys([lastItem.id.toString()]);
      }
    } else {
      setActiveKeys(prev => prev.filter(key => 
        section.items.some(item => item.id.toString() === key)
      ));
    }
    
    prevItemsLength.current = currentLength;
  }, [section?.items]);

  if (!section) return null;

  const handleAddItem = () => {
    if (!section || !section.id) {
      console.error('Sezione non valida o ID mancante');
      return;
    }
    setActiveKeys([]);
    onAddItem(section.id);
  };

  const handleAccordionSelect = (key) => {
    setActiveKeys(prev => {
      // Se la chiave cliccata è già attiva, chiudi l'accordion
      if (prev.includes(key)) {
        return prev.filter(k => k !== key);
      }
      // Altrimenti, apri solo quella cliccata
      return [key];
    });
  };

  const renderMenuItems = () => {
    if (!section?.items || !Array.isArray(section.items)) {
      return null;
    }

    if (section.items.length > 1) {
      return (
        <Accordion 
          activeKey={activeKeys}
          onSelect={handleAccordionSelect}
          className="clean-accordion"
        >
          {section.items.map(item => {
            if (!item) return null;

            return (
              <Accordion.Item 
                eventKey={item.id?.toString()} 
                key={item.id}
                className="border-0 mb-2"
              >
                <Accordion.Header className="clean-header">
                  <div className="d-flex align-items-center w-100">
                    <div
                      onClick={(e) => {
                        e.stopPropagation();
                        if (section?.id && item?.id) {
                          onRemoveItem(section.id, item.id);
                        }
                      }}
                      className="btn-sm me-3 text-danger cursor-pointer"
                    >
                      <Trash size={16} />
                    </div>
                    <span style={{ opacity: item.name ? 1 : 0.5 }}>
                      {item.name || 'carne/pesce/bevanda'}
                    </span>
                  </div>
                </Accordion.Header>
                <Accordion.Body className="px-3 py-4">
                  <MenuItem
                    item={item}
                    onUpdateItem={(field, value) => onUpdateItem(section.id, item.id, field, value)}
                    onRemoveItem={() => onRemoveItem(section.id, item.id)}
                    onFileUpload={onFileUpload}
                  />
                </Accordion.Body>
              </Accordion.Item>
            );
          })}
        </Accordion>
      );
    } else if (section.items.length === 1) {
      const item = section.items[0];
      if (!item) return null;

      return (
        <div key={item.id}>
          <div className="d-flex align-items-center mb-3">
            <div
              onClick={() => onRemoveItem(section.id, item.id)}
              className="btn-sm me-3 text-danger cursor-pointer"
            >
              <Trash size={16} />
            </div>
            
            <span style={{ opacity: item.name ? 1 : 0.5 }}>
              {item.name || 'piatto/bevanda'}
            </span>
          </div>
          
          <MenuItem
            item={item}
            onUpdateItem={(field, value) => onUpdateItem(section.id, item.id, field, value)}
            onRemoveItem={() => onRemoveItem(section.id, item.id)}
            onFileUpload={onFileUpload}
          />
        </div>
      );
    }
    return null;
  };

  const renderMoveButtons = () => {
    const isMobile = window.innerWidth <= 768;
    
    if (isMobile) {
      return (
        <div className="move-buttons d-flex flex-column me-2">
          {index > 0 && (
            <Button 
              variant="link" 
              className="p-1" 
              onClick={() => onMoveSection(index, 'up')}
            >
              <ArrowUpShort size={20} />
            </Button>
          )}
          {index < totalSections - 1 && (
            <Button 
              variant="link" 
              className="p-1" 
              onClick={() => onMoveSection(index, 'down')}
            >
              <ArrowDownShort size={20} />
            </Button>
          )}
        </div>
      );
    }

    return (
      <div className="move-buttons d-flex me-2">
        {index > 0 && (
          <Button 
            variant="link" 
            className="p-1" 
            onClick={() => onMoveSection(index, 'left')}
          >
            <ArrowLeftShort size={20} />
          </Button>
        )}
        {index < totalSections - 1 && (
          <Button 
            variant="link" 
            className="p-1" 
            onClick={() => onMoveSection(index, 'right')}
          >
            <ArrowRightShort size={20} />
          </Button>
        )}
      </div>
    );
  };

  return (
    <div className="menu-section">
      <Card className="mb-4 shadow-sm rounded-3">
        <Card.Body className="p-4">
          <Row className="align-items-center mb-4">
            <Col className="d-flex align-items-center">
              {renderMoveButtons()}
              <Form.Select
                value={section.name || ''} // Use empty string as fallback
                onChange={(e) => onUpdateSection(section.id, 'name', e.target.value)}
                className="form-control-lg"
              >
                {SECTION_TYPES.map(type => (
                  <option key={type.id} value={type.id}>
                    {type.name}
                  </option>
                ))}
              </Form.Select>
              <Button
                variant="link"
                className="text-danger ms-3"
                onClick={() => setShowModal(true)}
              >
                <Trash size={20} />
              </Button>
            </Col>
          </Row>
          
          <div className="menu-items-container">
            {renderMenuItems()}
          </div>
          
          <div className="d-flex justify-content-end mt-4">
            <Button 
              onClick={handleAddItem}
              variant="dark"
              className="d-flex align-items-center justify-content-center"
              style={{ 
                width: '40px', 
                height: '40px',
                padding: 0,
                borderRadius: '4px'
              }}
            >
              <Plus size={24} />
            </Button> 
          </div>
        </Card.Body>
      </Card>

      <Modal 
        show={showModal} 
        onHide={handleCloseModal}
        dialogClassName="delete-confirmation-dialog" // Use dialogClassName instead of className
        centered
      >
        <Modal.Header closeButton className="bg-white border-bottom">
          <Modal.Title>Conferma Cancellazione</Modal.Title>
        </Modal.Header>
        <Modal.Body className="bg-white">
          Sei sicuro di voler cancellare l'intera sezione? Tutti i piatti/bevande associati saranno cancellati.
        </Modal.Body>
        <Modal.Footer className="bg-white border-top">
          <Button variant="secondary" onClick={handleCloseModal}>
            Annulla
          </Button>
          <Button variant="danger" onClick={handleConfirmDelete}>
            Conferma Eliminazione
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default MenuSection;